import { InputNumber, InputNumberProps } from 'antd'
import { valueType } from 'antd/es/statistic/utils'

export const InputParsedNumber = <T extends valueType>(
  props: InputNumberProps<T>
) => (
  <InputNumber parser={(value) => value?.replace(',', '.') as T} {...props} />
)
